import { render, staticRenderFns } from "./DeliveryDescription.vue?vue&type=template&id=019e9470&"
import script from "./DeliveryDescription.vue?vue&type=script&lang=js&"
export * from "./DeliveryDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports